module.exports = __webpack_public_path__ + "static/2-f157096d36740d30d9c1942802024865.jpg";